import React, { ReactNode } from 'react';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: () => void;
    loading?: boolean;
    title?: string;
    children?: ReactNode;
    confirmText?: string;
    cancelText?: string;
    showFooter?: boolean;
    width?: string; // Add width prop
    height?: string; // Add height prop
}

const Modal: React.FC<ModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    loading = false,
    title,
    children,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    showFooter = true,
    width = 'max-w-md', // Default width
    height = 'auto', // Default height
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className={`bg-white rounded-lg shadow-lg ${width} ${height} mx-4 max-h-[80%] overflow-y-auto`}>
                {title && (
                    <div className="border-b px-6 py-4">
                        <h2 className="text-lg font-semibold">{title}</h2>
                    </div>
                )}

                <div className="px-6 py-4">{children}</div>

                {showFooter && (
                    <div className="border-t px-6 py-4 flex justify-end gap-3">
                        <button disabled={loading} onClick={onClose} className="transition py-2 px-4 rounded-xl font-semibold shadow-sm whitespace-nowrap border border-gray-300 hover:bg-gray-100">
                            {loading ? <div className="animate-spin h-6 w-6 border-2 border-purple-500 border-t-transparent rounded-full" /> : cancelText}
                        </button>
                        {onConfirm && (
                            <button disabled={loading} onClick={onConfirm} className="bg-gradient-purple hover:hover-gradient-purple transition text-white py-2 px-4 rounded-xl font-semibold shadow-sm whitespace-nowrap">
                                {loading ? <div className="animate-spin h-6 w-6 border-2 border-purple-500 border-t-transparent rounded-full" /> : confirmText}
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;
